import React from 'react';
import data from './data';

/*****************************************
 * EXPORTED FUNCTIONS
 *****************************************/
// will be used outside this file
const drawFunctions = {
  drawAll,
  drawInit,
};
export default drawFunctions;

/*****************************************
 * DRAWING FUNCTIONS
 *****************************************/

function drawInit(idx = 0) {
  // draw constant shape
  let points = [
    data.Xcor[0][0],
    data.Ycor[0][0],
    data.Xcor[1][0],
    data.Ycor[1][0],
    data.Xcor[2][0],
    data.Ycor[2][0],
    data.Xcor[3][0],
    data.Ycor[3][0],
  ];

  let stroke = '#333';
  let strokeOpacity = '.2';
  let strokeWidth = 0.5;

  if (idx === 0) {
    stroke = stroke = '#00426F';
    strokeOpacity = 1;
  }

  let str = [
    <polygon
      key="1"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeOpacity={strokeOpacity}
      fill="transparent"
      points={points}
    />,
  ];
  return str;
}

function drawDots(idx) {
  const numberOfDots = 2 ** (idx + 2);

  // draw constant shape

  let str = drawInit(idx);

  let points = [];
  for (let i = 0; i < numberOfDots; i++) {
    points.push(data.Xcor[i][idx]);
    points.push(data.Ycor[i][idx]);
  }
  str.push(
    <polygon
      key="2"
      stroke="#00426F"
      strokeWidth="0.5"
      fill="transparent"
      points={points}
    />
  );

  for (let i = 0; i < numberOfDots; i++) {
    str.push(
      <circle
        key={3 + i}
        // stroke="rgb(85, 8, 228)"
        strokeWidth="0.1"
        fill="#30A3B0"
        cx={data.Xcor[i][idx]}
        cy={data.Ycor[i][idx]}
        r="1"
      />
    );
  }

  return str;
}

function drawAll(idx) {
  // console.log('[DRAW-ALL]');
  const svgStr = drawDots(idx);
  return svgStr;
}
